import React from 'react';
import PropTypes from 'prop-types';

const InputDate = ({ id, placeHolder }) => (
  <input type="date" name={id} id={id} placeholder={placeHolder} clsssname="is-disabled" />
);

export default InputDate;

InputDate.propTypes = {
  placeHolder: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};
